import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminProfile = () => {
  const [adminData, setAdminData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userRole = localStorage.getItem('userRole');
    
    if (!token || userRole !== 'admin') {
      navigate('/');
      return;
    }

    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    setAdminData(userData);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    localStorage.removeItem('userData');
    navigate('/');
  };

  if (!adminData) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
        <div>Loading admin profile...</div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <header style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        padding: '1rem 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <h1 style={{ color: 'white', margin: 0 }}>AMALIKA WORLD</h1>
              <span style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Admin Portal</span>
            </div>
            <button 
              onClick={handleLogout}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                color: 'white',
                padding: '0.5rem 1rem',
                borderRadius: '25px',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main style={{ padding: '2rem 0' }}>
        <div className="container">
          <div style={{
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: '2rem',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
          }}>
            <h1>Welcome to Admin Panel, {adminData.firstName}!</h1>
            <p>This is the admin dashboard. More features coming soon...</p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '1rem',
              marginTop: '2rem'
            }}>
              <div style={{
                background: 'white',
                padding: '1.5rem',
                borderRadius: '10px',
                border: '1px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <h3>Users</h3>
                <p style={{ fontSize: '2rem', color: '#667eea', margin: 0 }}>150</p>
              </div>
              
              <div style={{
                background: 'white',
                padding: '1.5rem',
                borderRadius: '10px',
                border: '1px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <h3>Courses</h3>
                <p style={{ fontSize: '2rem', color: '#667eea', margin: 0 }}>25</p>
              </div>
              
              <div style={{
                background: 'white',
                padding: '1.5rem',
                borderRadius: '10px',
                border: '1px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <h3>Teachers</h3>
                <p style={{ fontSize: '2rem', color: '#667eea', margin: 0 }}>8</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminProfile;